import ComponentsFactory from 'foundation/components-factory';
import BallotCtaComponent from './js/ballot-cta.component';

ComponentsFactory.getInstance().define('ballot-cta', BallotCtaComponent);
